import { render, staticRenderFns } from "./VistaPreviaConfecion.vue?vue&type=template&id=2bc0aeb8&"
import script from "./VistaPreviaConfecion.vue?vue&type=script&lang=js&"
export * from "./VistaPreviaConfecion.vue?vue&type=script&lang=js&"
import style0 from "./VistaPreviaConfecion.vue?vue&type=style&index=0&id=2bc0aeb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports